var THF = THF || {};
THF.Interface = THF.Interface || {};

(function ($, jQuery) {
    'use strict';

    THF.Interface.NewsCategoryPageTracking = function (options) {

        var defaults = {

            selectors: {
                parentElem: '.news-category',
                categoryCTAs: '.categories-ctas',
                categoryTiles: '.category-tile'               
            }
        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var parentElem = $(options.selectors.parentElem);
        var categoryCTAs = $parentElem(options.selectors.categoryCTAs);
        var categoryTiles = categoryCTAs.find(options.selectors.categoryTiles);       



        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }


        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {

            /* Category Page: Article Tiles in the 'Browser more articles' */
            categoryTiles.each(function () {
                var categoryTile = $(this);
                var categoryTileButton = categoryTile.find('a');

                categoryTileButton.click(function (e) {
                    // e.preventDefault();
                    //console.log('Category Page >> Browse More Articles >> Category Tile Clicked.');
                    //console.log($(this).attr('href'));
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'categoryBrowseMoreCard',
                        'type': 'Category',
                        'pagePath': $(this).attr('href')
                    });
                });
            });           
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };
})(jQuery, jQuery)